"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _context = require("../../context");

var _utils = require("../../utils");

var _constants = require("./constants");

var _core = require("@emotion/core");

var _excluded = ["children", "isDisabled"];
var DisabledMarker = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterProps)(['markerWidth', 'markerHeight', 'wrapperWidth', 'wrapperHeight'])
})(function (_ref) {
  var theme = _ref.theme,
      _ref$markerWidth = _ref.markerWidth,
      markerWidth = _ref$markerWidth === void 0 ? _constants.DISABLED_STRIKETHROUGH_WIDTH : _ref$markerWidth,
      _ref$markerHeight = _ref.markerHeight,
      markerHeight = _ref$markerHeight === void 0 ? _constants.DISABLED_STRIKETHROUGH_HEIGHT : _ref$markerHeight,
      _ref$wrapperWidth = _ref.wrapperWidth,
      wrapperWidth = _ref$wrapperWidth === void 0 ? _constants.DATE_MARKER_SIZE : _ref$wrapperWidth,
      _ref$wrapperHeight = _ref.wrapperHeight,
      wrapperHeight = _ref$wrapperHeight === void 0 ? _constants.CALENDAR_CELL_SIZE : _ref$wrapperHeight;
  return {
    width: wrapperWidth,
    height: wrapperHeight,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '::before': {
      content: '""',
      position: 'absolute',
      top: (wrapperHeight - markerHeight) / 2,
      width: markerWidth,
      height: markerHeight,
      backgroundColor: theme.selectors.color('red70'),
      border: "1px solid ".concat(theme.selectors.color('neutral0'))
    }
  };
});

var DisabledDateMarker = function DisabledDateMarker(_ref2) {
  var children = _ref2.children,
      isDisabled = _ref2.isDisabled,
      innerProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);

  if (!isDisabled) {
    return (0, _core.jsx)(_react.default.Fragment, null, children);
  }

  return (0, _core.jsx)(DisabledMarker, innerProps, children);
};

var _default = DisabledDateMarker;
exports.default = _default;